import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import ReactModal from 'react-modal';
import Button from '../../../atoms/buttons/Button';
import { isDarkMode } from '../../../utils/helpers';
import { SvgIcon } from '@material-ui/core';
import { CancelRounded } from '@material-ui/icons';
import { bottomLinkStyle, closeButton } from '../../../components/common/CommonStyle';
import { VerifiedIcon } from '../../../atoms/icons/IDVIcons';
import JoinSkipButton from '../../../components/join/JoinSkipButton';
import { s3BucketContentDir } from '../../../config/Master';
import useMediaBreakpoints from '../../../hooks/useMediaBreakpoints';
import breakpoints from '../../../theme/material/breakpoints';
import {
  ButttonWrapper,
  ClosedButton,
  Description,
  HeadingWrapper,
  ImageWrapper,
  List,
  Title,
  buttonCustomStyle,
  defaultModalStyle,
  iconStyle,
} from './VerificationModalStyle';

const ImgIDV = `${s3BucketContentDir}idv/idv_new.png`;
const ImgIDVDark = `${s3BucketContentDir}idv/idv_new_dark.png`;

ReactModal.setAppElement('body');

const setModalStyle = (customStyle: { overlay: any; content: any }, isMobile: boolean, darkMode: boolean) => {
  const customOverlay = customStyle.overlay || {};
  const customContent = customStyle.content || {};

  return {
    overlay: {
      ...customOverlay,
    },
    content: {
      ...customContent,
      top: isMobile ? 20 : 72,
      padding: isMobile ? '20px 0px 30px 0px' : '20px 30px 30px 30px',
      maxWidth: isMobile ? '345px' : '450px',
      maxHeight: isMobile ? '90vh' : '735px',
      height: isMobile ? 'auto' : 'auto', // allow content to define height
      border: darkMode ? '1px solid #6c6c6c' : 'none',
    },
  };
};

const Content = styled('div')({
  margin: '0px 30px 0px 50px',
  [breakpoints.down(1024)]: {
    margin: '0px 30px 0px 30px',
  },
});

interface ConfirmVerificationModalProps {
  onClose: any;
  hideClose?: boolean;
  onConfirm: any;
  [keys: string]: any;
}

const ConfirmVerificationModal = ({
  onClose,
  hideClose,
  onConfirm,
  ...rest
}: ConfirmVerificationModalProps): ReactElement => {
  const { isMobile } = useMediaBreakpoints();
  const darkMode = isDarkMode();

  return (
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    <ReactModal
      style={setModalStyle(defaultModalStyle(), isMobile, darkMode)}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onClose}
      {...rest}
    >
      {!hideClose && (
        <ClosedButton onClick={onClose}>
          <SvgIcon component={CancelRounded} style={closeButton} />
        </ClosedButton>
      )}

      <ImageWrapper>
        <img src={isDarkMode() ? ImgIDVDark : ImgIDV} alt="idv-photo" />
      </ImageWrapper>
      <Content>
        <HeadingWrapper>
          <Title customStyle={{ display: 'inherit', margin: '0px 8px 0px 0px' }}>Get</Title>
          <VerifiedIcon customStyle={iconStyle} fillColor={'#2B8FD7'} />
          <Title>ID Verified!</Title>
        </HeadingWrapper>
        <Description>
          Show everyone you’re the real deal by getting ID Verified! It’s fast, safe and totally secure.
        </Description>
        <List>
          <li>Verification provided by a trusted third-party (Au10tix.com), using two methods of identification</li>
          <li>Help keep WhatsYourPrice free from flakes and snakes</li>
          <li>Foster trust and get more offers</li>
          <li>
            Show off with a <span style={{ fontWeight: 700 }}>blue profile badge </span>
          </li>
          <li>
            <span style={{ fontWeight: 700 }}>Get our most robust verification for only $4.99!</span>
          </li>
        </List>
        <ButttonWrapper>
          <Button buttonType="primaryRed" onClick={onConfirm} customStyle={buttonCustomStyle}>
            Get ID Verification
          </Button>
          <JoinSkipButton
            dataTestId="maybe-later-link"
            label="Maybe later"
            customWrapperStyle={{ textAlign: 'center', marginTop: 10 }}
            customStyle={{ ...bottomLinkStyle, fontSize: '11px', fontWeight: 400 }}
            onClick={onClose}
          />
        </ButttonWrapper>
      </Content>
    </ReactModal>
  );
};

export default ConfirmVerificationModal;
